<template>
    <div>
        <GmapMap
                :center="{lat: 54.359087, lng: -5.709261}"
                :zoom="16"
                map-type-id="terrain"
                style="width: 100%; height: 500px"
        >
            <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="true"
                    @click="center=m.position"
            />
        </GmapMap>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                markers: [{
                    position: {lat: 54.359087, lng: -5.709261}
                }]
            }
        }
    }
</script>